import generateBusinessBudgetKey from 'businessTraveller/utils/generateBusinessBudgetKey'
import { createSelector } from 'reselect'
import { getLocationDataFromOffer } from 'businessTraveller/utils/getLocationDataFromOffer'

export const selectBusinessTravellerAccommodationBudget = createSelector(
  (state: App.State) => state.businessTraveller.businessBudgets,
  (state: App.State) => state.checkout.cart,
  (state: App.State) => state.offer,
  (state: App.State) => state.geo.currentCurrency,
  (
    budgetData,
    cartData,
    offerData,
    currentCurrency,
  ): App.BusinessTraveller.BusinessBudget | null => {
    if (cartData.items.length === 0 || Object.keys(offerData.offers).length === 0 || Object.keys(budgetData).length === 0) {
      return null
    }

    const cartOffer = cartData.items[0] as App.Checkout.AccommodationItem

    const offer = offerData.offers[cartOffer.offerId]

    // If offer with offerKey doesn't exist
    if (!offer) {
      return null
    }

    const locationData = getLocationDataFromOffer(offer)

    const budgetKey = generateBusinessBudgetKey({
      currencyCode: currentCurrency,
      longitude: locationData.location.longitude,
      latitude: locationData.location.latitude,
    })

    const accommodationBudgets = budgetData[budgetKey]?.budgets

    if (accommodationBudgets?.length) {
      return accommodationBudgets[0]
    }

    return null
  },
)
